<template>
  <v-container fill-height>
    <div :style="{position: 'absolute', top:'0', right:0}">
      <dark-mode></dark-mode>
    </div>
    <gallery-menu :nav="menu"> </gallery-menu>
  </v-container>
</template>

<script>
import menuConfig from "@/menu-config/menu-config"
import GalleryMenu from "@/layout/GalleryMenu/GalleryMenu";
import {DarkMode} from "@dracul/customize-frontend"

export default {
  name: "HomeAdminPage",
  components: {GalleryMenu, DarkMode},
  computed: {
    menu() {
      return menuConfig
    }
  }
}
</script>

<style scoped>

</style>
